<template>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="row">
      <div class="col-sm-12">
        <div id="resultsHeader">
          <div class="checkboxCol"></div>
          <div class="doubleCol">Name</div>
          <div class="normalCol">Make</div>
          <div class="normalCol">Model</div>
          <div class="normalCol">Type</div>
          <div class="normalCol">Serial</div>
        </div>
      </div>
    </div>
    <div class="row" v-for="asset in assets" :key="asset.id">
      <router-link :to="{name: 'AssetsJobs', params: { id: asset.id }}">
      <div class="col-sm-12">
        <div id="resultsBody">
          <div class="checkboxCol"></div>
          <div class="doubleCol">{{ asset.name }}</div>
          <div class="normalCol">{{ asset.make }}</div>
          <div class="normalCol">{{ asset.model }}</div>
          <div class="normalCol">{{ asset.type }}</div>
          <div class="normalCol">{{ asset.serial }}</div>
        </div>
      </div>
      </router-link>
    </div>
    <div class="row" id="resultsFooterLink">
      <div class="col-sm-12">
        <div align="center">
          <router-link :to="{name: 'RelationshipsAssetNew', params: { id: $route.params.id }}"><font-awesome-icon icon="plus" /> Add New Asset</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      assets: []
    }
  },
  created () {
    axios
      .get(`/api/companies/${this.$route.params.id}/assets`)
      .then(response => {
        this.assets = response.data
      })
  },
  methods: {
  }
}
</script>
